export const TYPE = "congtyxuat"
